module.exports = __webpack_public_path__ + "img/career-06.b6fab8ce.jpg";